import { ValidationSchemaType } from 'hooks/useForm';
import { Terminal } from '../types/dtos';

export const TERMINAL_INITIAL_FIELDS: Terminal = {
    name: '',
    description: '',
    deviceId: '',
    deviceType: 'TABLET',
    status: 'CLOSED',
    email: '',
    password: '',
    accountId: '',
};

export const TERMINAL_CREATE_FIELDS_SCHEMA: ValidationSchemaType<Terminal> = {
    name: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    status: {
        required: true,
    },
    deviceType: {
        required: true,
    },
    deviceId: {
        required: true,
    },
    email: {
        type: 'email',
    },
    password: {
        required: true,
        maxLength: 50,
        minLength: 3,
    },
};

export const TERMINAL_EDIT_FIELDS_SCHEMA: ValidationSchemaType<Terminal> = {
    name: {
        required: true,
        maxLength: 100,
        minLength: 3,
    },
    status: {
        required: true,
    },
    deviceType: {
        required: true,
    },
    deviceId: {
        required: true,
    },
    email: {
        type: 'email',
    },
};
